// src/App.js
import React, { Suspense, lazy } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";

// Eager: homepage (uses global App.css)
import HomePage from "./components/HomePage";

// Lazy-load pages that import their own CSS
const SealDocumentPage     = lazy(() => import("./components/SealDocumentPage"));
const VerifyPage           = lazy(() => import("./components/VerifyDocumentPage"));
const DashboardPage        = lazy(() => import("./components/DashboardPage"));
const HashSealOnboarding   = lazy(() => import("./components/HashSealOnboarding"));
const CaseStudiesIndex     = lazy(() => import("./components/CaseStudiesIndex"));
const CaseStudyPage        = lazy(() => import("./components/CaseStudyPage"));

const EducationPage        = lazy(() => import("./pages/EducationPage"));
const InsurancePage        = lazy(() => import("./pages/InsurancePage"));
const ESGPage              = lazy(() => import("./pages/ESGPage"));
const SportsPage           = lazy(() => import("./pages/SportsCertificatesPage"));
const MuseumPage            = lazy(() => import("./pages/ArtHeritagePage"));
const FraudQuakeMap        = lazy(() => import("./pages/FraudQuakeMap"));
const EducationSurvey      = lazy(() => import("./pages/EducationHrSurvey"));

const TermsPage            = lazy(() => import("./pages/TermsPage"));
const PrivacyPage          = lazy(() => import("./pages/PrivacyPage"));
const CookiePage          = lazy(() => import("./pages/CookiePolicy"));
const NotFoundPage         = lazy(() => import("./pages/NotFoundPage"));

export default function App() {
  return (
    <HelmetProvider>
      <Suspense fallback={<div style={{ padding: 24 }}>Loading…</div>}>
        <Routes>
          {/* Core */}
          <Route path="/" element={<HomePage />} />
          <Route path="/seal"        element={<SealDocumentPage />} />
          <Route path="/verify"      element={<VerifyPage />} />
          <Route path="/dashboard"   element={<DashboardPage />} />
          <Route path="/onboarding"  element={<HashSealOnboarding />} />

          {/* Verticals & features */}
          <Route path="/education"   element={<EducationPage />} />
          <Route path="/survey/education" element={<EducationSurvey />} />
          <Route path="/insurance"   element={<InsurancePage />} />
          <Route path="/esg"         element={<ESGPage />} />
          <Route path="/sports"   element={<SportsPage />}/>
          <Route path="/museum"   element={<MuseumPage />}
          />
          <Route path="/sightings"   element={<FraudQuakeMap />} />

          {/* Case studies */}
          <Route path="/case-studies"       element={<CaseStudiesIndex />} />
          <Route path="/case-studies/:slug" element={<CaseStudyPage />} />

          {/* Legal */}
          <Route path="/terms"   element={<TermsPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/" element={<PrivacyPage />} />

          {/* Optional legacy paths -> redirects */}
          <Route path="/legal/terms"   element={<Navigate to="/terms" replace />} />
          <Route path="/legal/privacy" element={<Navigate to="/privacy" replace />} />
          <Route path="/policy"        element={<Navigate to="/privacy" replace />} />

          {/* 404 */}
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Suspense>
    </HelmetProvider>
  );
}
